/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPlannedLaborCost } from '../fn/planned-labor-costs/create-planned-labor-cost';
import { CreatePlannedLaborCost$Params } from '../fn/planned-labor-costs/create-planned-labor-cost';
import { deletePlannedLaborCost } from '../fn/planned-labor-costs/delete-planned-labor-cost';
import { DeletePlannedLaborCost$Params } from '../fn/planned-labor-costs/delete-planned-labor-cost';
import { getPlannedLaborCost } from '../fn/planned-labor-costs/get-planned-labor-cost';
import { GetPlannedLaborCost$Params } from '../fn/planned-labor-costs/get-planned-labor-cost';
import { listPlannedLaborCosts } from '../fn/planned-labor-costs/list-planned-labor-costs';
import { ListPlannedLaborCosts$Params } from '../fn/planned-labor-costs/list-planned-labor-costs';
import { PlannedLaborCostDto } from '../models/planned-labor-cost-dto';
import { PlannedLaborCostDtoPage } from '../models/planned-labor-cost-dto-page';
import { updatePlannedLaborCost } from '../fn/planned-labor-costs/update-planned-labor-cost';
import { UpdatePlannedLaborCost$Params } from '../fn/planned-labor-costs/update-planned-labor-cost';

@Injectable({ providedIn: 'root' })
export class PlannedLaborCostsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listPlannedLaborCosts()` */
  static readonly ListPlannedLaborCostsPath = '/v0/plannedLaborCosts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPlannedLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPlannedLaborCosts$Response(params?: ListPlannedLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedLaborCostDtoPage>> {
    return listPlannedLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listPlannedLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPlannedLaborCosts(params?: ListPlannedLaborCosts$Params, context?: HttpContext): Observable<PlannedLaborCostDtoPage> {
    return this.listPlannedLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedLaborCostDtoPage>): PlannedLaborCostDtoPage => r.body)
    );
  }

  /** Path part for operation `getPlannedLaborCost()` */
  static readonly GetPlannedLaborCostPath = '/v0/plannedLaborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlannedLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedLaborCost$Response(params: GetPlannedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedLaborCostDto>> {
    return getPlannedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlannedLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlannedLaborCost(params: GetPlannedLaborCost$Params, context?: HttpContext): Observable<PlannedLaborCostDto> {
    return this.getPlannedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedLaborCostDto>): PlannedLaborCostDto => r.body)
    );
  }

  /** Path part for operation `updatePlannedLaborCost()` */
  static readonly UpdatePlannedLaborCostPath = '/v0/plannedLaborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlannedLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePlannedLaborCost$Response(params: UpdatePlannedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePlannedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlannedLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePlannedLaborCost(params: UpdatePlannedLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.updatePlannedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createPlannedLaborCost()` */
  static readonly CreatePlannedLaborCostPath = '/v0/plannedLaborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlannedLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPlannedLaborCost$Response(params: CreatePlannedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedLaborCostDto>> {
    return createPlannedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlannedLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPlannedLaborCost(params: CreatePlannedLaborCost$Params, context?: HttpContext): Observable<PlannedLaborCostDto> {
    return this.createPlannedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlannedLaborCostDto>): PlannedLaborCostDto => r.body)
    );
  }

  /** Path part for operation `deletePlannedLaborCost()` */
  static readonly DeletePlannedLaborCostPath = '/v0/plannedLaborCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePlannedLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedLaborCost$Response(params: DeletePlannedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePlannedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePlannedLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlannedLaborCost(params: DeletePlannedLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.deletePlannedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
